module.exports = __webpack_public_path__ + "img/36-02.7fed9edb.png";